import React, { Component } from 'react';


class VideoHero extends Component {
  render() {
    return (
    <div  
        className="hero-wrapper"
        
    >
        <div 
            class={"hero " + this.props.addClass}
        >
        <div class="video-hero-overlay"></div>

        <div className="hero-text-view">
            <h2 className="dalton">Dalton Wemer</h2>
            <h3 className="name-title">PROJECT SHOWCASE</h3>
        </div>
        

        <video 
            autoPlay
            playsInline
            muted 
            loop 
            src={this.props.video} 
            preload="none"
            className={"bg-video-hero"}
        >    
        </video>

        <div id="dark-sd-container" className="scroll-arrows-homepage">
            <div className="dark-arrow"></div>
            <div className="dark-arrow"></div>
        </div>
        </div>
       

    </div>
    
    );
  }
}

export default VideoHero;



// WEBPACK FOOTER //
// ./src/components/VideoHero.js